export default {
    success: 'User <strong>{email}</strong> was successfully created!',
    title: 'Create new user',
    new: 'User',
    reachedLimit: 'The maximum count of your users and manager/admin accounts for your company has been reached. First delete users to be able to create new users.'
}
